





















































import { Currency } from "@/shared/models/currency";
import { Component, PropSync, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ReservationAccUnitModel } from "./types";
import WorkingCurrencyDisplay from "@/components/misc/WorkingCurrencyDisplay.vue";
import TimeField from "@/components/misc/TimeField.vue";

@Component({ components: { WorkingCurrencyDisplay, TimeField } })
export default class ReservationFormUnitFields extends Vue {
  @PropSync("unit", { default: undefined }) model?: ReservationAccUnitModel;

  // prettier-ignore
  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Getter("appParams/reservationHideArrivalDeparture") reservationHideArrivalDeparture?: boolean;
  @Getter("appParams/reservationHideDeposit") reservationHideDeposit?: boolean;

  async created() {
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      await this.refreshCurrencies();
    }
  }

  get showArrivalDeparture()
  {
    return !this.reservationHideArrivalDeparture;
  }

  get showDeposit()
  {
    return !this.reservationHideDeposit;
  }

  get hasDeposit() {
    return !!this.model?.damageDeposit || this.model?.damageDeposit === 0;
  }

  countDecimals(num: number) {
    return num.toString().split(".")[1]?.length || 0;
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      noNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
      maxDecimals: (value: any) =>
        !(this.countDecimals(+value) > 2) ||
        this.$t("Validation.CanOnlyHaveTwoDecimals"),
    };
  }
}
